// extracted by mini-css-extract-plugin
export default {"investors":"Investors-module--investors---sZX3","header":"Investors-module--header--nKk9y","title":"Investors-module--title--XSK+L"};